<template>
  <v-list>
    <template v-for="(item, index) in leaderboard" max-height="55px" dense>
      <v-list-item
        :key="item.name"
        @click="goToAgent(item)"
        style="max-height: 55px !important"
      >
        <v-row class="text-center d-flex align-center" v-if="item.score !== ''">
          <!-- Name -->
          <v-col cols="5" class="text-left d-flex align-center">
            <v-list-item-title
              v-text="item.name"
              :class="item.color"
            ></v-list-item-title>
          </v-col>
          <!-- Score -->
          <v-col cols="7" class="d-flex align-center">
            <v-col
              v-if="item.courseName !== null"
              cols="9"
              :class="interactionClass"
            >
              <v-row class="justify-left">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      span
                      v-bind="attrs"
                      v-on="on"
                      class="course-text-value d-flex align-center d-inline-block text-truncate"
                      style="max-width: 140px;"
                      >{{ item.courseName }}</span
                    >
                  </template>
                  <span
                    >Scenario: {{ item.courseName }}<br />Date: {{ item.date
                    }}<br />Time: {{ item.time }}</span
                  >
                </v-tooltip>
              </v-row>
            </v-col>
            <v-col
              v-if="item.courseName == null"
              cols="4"
              :class="interactionClass"
            >
              <v-row class="justify-center">
                <span class="interactions-text-label">Duration</span>
              </v-row>
              <v-row class="justify-center">
                <span class="interactions-text-value d-flex align-center">{{
                  item.timeSpent
                }}</span>
              </v-row>
            </v-col>
            <v-col
              v-if="item.courseName == null"
              cols="5"
              :class="interactionClass"
            >
              <v-row class="justify-center">
                <span class="caption font-italic">{{ item.date }}</span>
              </v-row>
              <v-row class="justify-center">
                <span class="caption font-italic">{{ item.time }}</span>
              </v-row>
            </v-col>
            <v-col cols="3">
              <v-row class="justify-center">
                <h3 :class="item.scoreColor">{{ item.score }}%</h3>
              </v-row>
            </v-col>
          </v-col>
        </v-row>
      </v-list-item>
      <v-divider
        v-if="index + 1 < leaderboard.length && item.score !== ''"
        :key="index"
      ></v-divider>
    </template>
    <v-list-item v-if="leaderboard.length === 0">
      <v-row class="justify-center">
        <span>No score data available!</span>
      </v-row>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    leaderboard: {
      type: Array,
      required: true
    },
    classScroll: {
      typre: String,
      default: 'overflow-y-auto',
      required: false
    }
  },
  computed: {
    interactionClass() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'd-none'
          break
        default:
          return 'body-1 font-weight-light'
      }
    }
  }
}
</script>

<style>
.my-border {
  border-style: solid;
}
.score-text {
  color: #7ed321;
}
.score-text-failed {
  color: #f5a623;
}
.time-spent-text {
  color: #75b9be;
}
.interactions-text-label {
  font-size: 0.8em;
  color: gray;
  text-align: center;
}
.interactions-text-value {
  font-size: 0.9em;
  color: gray;
  font-weight: bold;
  text-align: center;
}

.course-text-label {
  font-size: 0.7em;
  color: gray;
  text-align: center;
}
.course-text-value {
  font-size: 0.6em;
  color: gray;
  font-weight: bold;
  text-align: center;
}
</style>
